// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import StyledCard from '@/components/global-components/styled-card/StyledCard';

// Themes
import theme from '@/themes/index';

const Information = ({
  content: {
    fullImage = {},
    text,
  },
  isDesktop,
}) => {
  return (
    <>
      <div className='post-container'>
        <StyledCard 
          content={{
            image: fullImage,
          }}
          containerStyle={{
            flexDirection: 'column-reverse', 
          }}
          infoContainerStyle={{
            padding: '0',
            display: 'flex',
            flexDirection: 'column',
          }}
          imageStyles={{
            width: '100%',
            maxHeight: isDesktop ? '25rem' : '100%',
          }}
        >
          <RichText render={text} />
        </StyledCard>
      </div>
      <style global jsx>{`

        div.post-container .container .info-container ul {
          padding-inline-start: 1.3rem;
          text-align: justify;
        }

        div.post-container .container .info-container ul li {
          padding-bottom: 1rem;
          font-family: ${theme.fontFamilies.openSans};
        }
      `}</style>
    </>
  );
};

export default Information;
